// 学生管理管理接口文档地址
// http://rap2.10niu.cn/repository/editor?id=21&mod=337&itf=2147
// http://gitlab.10niu.cn/organization/repository/editor?id=21&mod=337&itf=3202
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const safety = {
	/**
	 * 学生管理2.0（新版）
	 */
	// 1.获取班级年级列表
	getGradeClassList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/grade/get_grade_class_list`,
			headers: config.headers,
			params
		});
	},
	// 获取年级code列表
	getGradeCodeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/grade/get_grade_code_list`,
			headers: config.headers,
			params
		});
	},
	// 添加年级
	getAddGrade(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/grade/add_grade`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑年级
	getUpdateGrade(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/grade/update_grade`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除年级
	getDeleteGrade(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/grade/delete_grade`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 添加班级
	getAddClass(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/class/add_class`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑班级
	getUpdateClass(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/class/update_class`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除班级
	getDeleteClass(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/class/delete_class`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 根据渠道代理商获取学校列表
	getSchoolList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school/get_oem_agent_school_list`,
			headers: config.headers,
			params
		});
	},
	// 获取家长称呼列表
	getParentCallList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/student-parent/get_parent_call_list`,
			headers: config.headers,
			params
		});
	},
	// 获取学生列表
	getStudentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/student/get_class_student_list`,
			headers: config.headers,
			params
		});
	},
	// 获取家长微信绑定状态列表
	getBindWxList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/student-parent/get_student_parent_bind_wx_list`,
			headers: config.headers,
			params
		});
	},
	// 单个学生调班级
	getChangeClass(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student/change_class`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 解绑学生与家长关系
	getUnbindStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student-parent/unbind_student_parent`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 添加学生
	getAddStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student/add_student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑学生
	getUpdateStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student/update_student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除学生
	getDeleteStudent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student/delete_student`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取学生标识列表
	getStudentLabelList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/student/get_student_label_list`,
			headers: config.headers,
			params
		});
	},
	// 添加家长副号
	getAddDeputyParent(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student-parent/add_deputy_parent`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 修改家长手机号称呼

	getUpdateParent(data) {
		return requestByGateway({
			method: 'post',
			// url: `${config.api.admin}/student-parent/update_parent`,
			url: `${config.api.admin}/student-parent/update_relation`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 设置卡状态
	getCardStatus(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/card/set_card_status`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 添加学生卡
	getAddCard(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/card/add_card`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取学生卡列表
	getStudentCardList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/card/get_student_card_list`,
			headers: config.headers,
			params
		});
	},
	/**
	 * 导入导出模块
	 */
	// 新版后台_导入导出_Excel模板下载
	getDownTemplate(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/import-export/download_template`,
			headers: config.headers,
			params
		});
	},
	// 新版后台_导入导出_表格上传
	postUploadExcel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/import-export/upload_excel`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 新版后台_导入导出_数据导出
	postExportExcel(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/import-export/export_excel`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 新版后台_导入导出_导入导出列表
	getImportExportList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/import-export/import_export_list`,
			headers: config.headers,
			params
		});
	},
	// 新版后台_导入导出_获取导入导出实时状态
	getRealtimeStatus(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/import-export/realtime_status`,
			headers: config.headers,
			params
		});
	},
	// 新版后台_导入导出_导入导出状态切换
	postStateSwitch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/import-export/state_switch`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 新版后台_导入导出_导入结果列表
	getImportResultList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/import-export/import_result_list`,
			headers: config.headers,
			params
		});
	},

	// ==============================
	// 获取正在下载记录
	getDownList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/queue-job/get_downloading_list`,
			headers: config.headers,
			params
		});
	},
	// 获取下载详情
	// 重启下载
	getRetryDownload(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/retry_download`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 暂停下载
	getPauseDownload(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/pause_download`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除下载记录
	getDeleteDownloadRecord(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/delete_download_record`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取正在上传记录
	getUpList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/queue-job/get_uploading_list`,
			headers: config.headers,
			params
		});
	},
	// 获取上传详情
	// 重启上传
	getRetryUpload(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/retry_upload`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 暂停上传
	getPauseUpload(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/pause_upload`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 删除上传记录
	getDeleteUploadRecord(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/delete_upload_record`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取历史记录
	getHistoryRecord(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/queue-job/get_history_record`,
			headers: config.headers,
			params
		});
	},
	// 导出学生模板
	getExportStudentTemplate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/export_student_template`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 导出学生信息表
	getExportStudentTable(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/export_student_data_table`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 创建导入新增学生信息队列任务
	getCreateImportAddStudentJob(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/create_import_add_student_job`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 批量上传新建学生信息
	getImportAddStudent(data) {
		return requestByGateway({
			method: 'post',
			headers: {
				'Content-Type': 'application/json'
			},
			url: `${config.api.admin}/queue-job/import_add_student`,
			// headers: config.headers,
			data
		});
	},
	// 创建导入更新学生信息队列任务

	getCreateImportUpStudentJob(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/queue-job/create_import_update_student_job`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 批量上传更新学生信息
	getImportUpStudent(data) {
		return requestByGateway({
			method: 'post',
			headers: {
				'Content-Type': 'application/json'
			},
			url: `${config.api.admin}/queue-job/import_update_student`,
			// headers: config.headers,
			data
		});
	},
	// 获取导入结果列表
	getImportResultList1(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/queue-job/get_import_result_list`,
			headers: config.headers,
			params
		});
	},
	// 获取单个学生家长列表
	getStudentParentList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/student-parent/get_student_parent_list`,
			headers: config.headers,
			params
		});
	},
	// 微信解绑
	getUnbindWechat(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student-parent/unbind_wechat`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取学段年级结构列表
	getPeriodGradeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/grade/get_period_grade_list`,
			headers: config.headers,
			params
		});
	},
	// 根据年级id分页获取年级下的班级详细信息
	getGradeClassDetailList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/class/get_grade_class_detail_list`,
			headers: config.headers,
			params
		});
	},
	// 班级_更新未划分年级的班级
	getSetGradeBatch(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/class/not-divided/set_grade_batch`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 班级_更新单个未划分年级的班级
	getSetGradeSingle(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/class/not-divided/set_grade`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取未划分年级的年级列表
	getUndividedGradeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/grade/grade_list`,
			headers: config.headers,
			params
		});
	},
	// 解绑学生与家长关系_预检测
	unbindStudentParentCheck(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/student-parent/unbind_student_parent_check`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};
export default safety;
